import { queryOptions } from '@tanstack/react-query';

import API from '@api';

/**
 * Счётчик избранных товаров (бейдж в шапке). Без select: читается через
 * queryClient.fetchQuery из CatalogStore, который держит observable-зеркало
 * favoritesItemsAmount на переходный период.
 */
export const TOTAL_FAVORITES_QUERY_KEY = 'totalFavorites';

export const totalFavoritesQueryOptions = () =>
  queryOptions({
    queryKey: [TOTAL_FAVORITES_QUERY_KEY],
    queryFn: () => API.getTotalFavorites()
  });
